import React from "react";
import { HiLockClosed } from "react-icons/hi2";

export const CustomCheckbox = ({
  label,
  type,
  onClick,
  onChange,
  value,
  name,
  disabled,
}) => {
  const handleChange = onChange || onClick;

  return (
    <div className="inline-flex items-center">
      <label
        className="relative flex cursor-pointer items-center rounded-full p-3"
        htmlFor={name}
        data-ripple-dark="true"
      >
        <input
          id={name}
          type="checkbox"
          checked={value}
          onChange={handleChange}
          name={name}
          disabled={disabled}
          className={`before:content[''] peer relative h-5 w-5 cursor-pointer  rounded-md border border-blue-slate-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-success-100 checked:bg-success-100 checked:before:bg-success-100 hover:before:opacity-10 ${
            disabled
              ? "border-2 border-gray-200 appearance-none gray-200 bg-gray-100 cursor-not-allowed "
              : "border border-gray-300 "
          }`}
        />
        <div
          className={`pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4  opacity-0 transition-opacity peer-checked:opacity-100 ${
            disabled ? "text-black" : "text-white"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3.5 w-3.5"
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>
      </label>
      <label
        className="mt-px cursor-pointer select-none font-medium text-gray-500 uppercase"
        htmlFor={name}
      >
        {label} {disabled ? <HiLockClosed className="inline" /> : ""}
      </label>
    </div>
    /*  
    <div className="relative">
      <label className=" text-gray-500 text-xs font-medium uppercase tracking-wider bg-white px-1 left-2 -top-2">
        
      </label>
      <input
        
        className="border border-gray-300 rounded-lg p-2 pl-2 w-full focus:outline-primary-700"
        type={type}
        
      />
    </div>*/
  );
};
